export default __webpack_public_path__ + "static/BasisGrotesque-Bold-19ea0a481fc9560813d8de0461367fef.woff";